module.exports = __webpack_public_path__ + "static/media/Windows.5f105df1.svg";